export const MB = 1024 * 1024;

export const MAX_DOCUMENT_SIZE_BYTES = 10 * MB;
export const MAX_RECEIPT_SIZE_BYTES = 8 * MB;
export const MAX_SMART_UPLOAD_SIZE_BYTES = 10 * MB;
export const MAX_TRIP_MEMORY_SIZE_BYTES = 10 * MB;

export const DOCUMENT_ALLOWED_MIME_TYPES = new Set([
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/heic',
  'image/heif',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]);

export const DOCUMENT_ALLOWED_EXTENSIONS = new Set([
  'pdf',
  'jpg',
  'jpeg',
  'png',
  'heic',
  'heif',
  'doc',
  'docx',
]);

export const SMART_UPLOAD_ALLOWED_MIME_TYPES = new Set([
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/pjpeg',
]);

export const RECEIPT_ALLOWED_MIME_TYPES = new Set([
  'application/pdf',
  'image/jpeg',
  'image/jpg',
  'image/png',
]);

export const RECEIPT_ALLOWED_EXTENSIONS = new Set(['pdf', 'jpg', 'jpeg', 'png']);

export const TRIP_MEMORY_ALLOWED_MIME_TYPES = new Set([
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/heic',
  'image/heif',
]);

export const getFileExtension = (fileName: string): string => {
  const parts = fileName.split('.');
  if (parts.length < 2) return '';
  return parts.pop()?.toLowerCase() || '';
};

export const hasAllowedMimeOrExtension = (
  mimeType: string | null | undefined,
  fileName: string,
  allowedMimeTypes: Set<string>,
  allowedExtensions: Set<string>,
): boolean => {
  const normalizedMime = (mimeType || '').toLowerCase();
  const extension = getFileExtension(fileName);
  return allowedMimeTypes.has(normalizedMime) || allowedExtensions.has(extension);
};

